import api from '../../../../api/clients/api';

class TicketApi {
  async downloadDiscountedTickets(from: Date, to: Date) {
    const { data } = await api.get<{ content: string }>('reports/discounted-parking-tickets', {
      params: {
        from,
        to,
      },
    });

    return data;
  }
}

export const ticketApi = new TicketApi();
